import { getDateTimeFormat } from '@chilipiper/models'
import { Box, Flex, Text } from '@chilipiper/design-system'
import moment, { Moment } from 'moment-timezone'
import React from 'react'
import { useLocale, useTranslations } from '@chilipiper/locale'

interface Props {
  end?: Moment | number
  start?: Moment | number
  timeZone: string
}

export const PreviousPick = ({ start, end, timeZone }: Props) => {
  const locale = useLocale()
  const [previousDateTimeBooked] = useTranslations(['previousDateTimeBooked'])
  const date = start
    ? moment(start).tz(timeZone).format(getDateTimeFormat(locale)('dddd, MMM Do'))
    : ''
  const timeStart = start ? moment(start).tz(timeZone).format(getDateTimeFormat(locale)('LT')) : ''
  const timeEnd = end ? moment(end).tz(timeZone).format(getDateTimeFormat(locale)('LT')) : ''

  const previousPickDate = date && timeStart && timeEnd ? `${date} ${timeStart} - ${timeEnd}` : ''
  return (
    <Flex justifyContent='center'>
      <Flex
        mb={9}
        mt={5}
        borderRadius={['none', 8]}
        px={6}
        py={4}
        w='100%'
        minHeight='72px'
        maxWidth={['none', '360px', '480px']}
        bg='neutral-dark-4'
        flexDirection='column'
        data-chili-css='previous-pick'
      >
        <Box>
          <Box>
            <Text
              data-test-id='previous-date-time-pick'
              color='neutral-dark-80'
              fontSize={12}
              fontWeight={600}
              data-chili-css='previous-pick-title'
            >
              {previousDateTimeBooked}
            </Text>
          </Box>
          <Box>
            <Text data-chili-css='previous-pick-date' fontWeight={500} color='neutral-dark-100'>
              {previousPickDate}
            </Text>
          </Box>
        </Box>
      </Flex>
    </Flex>
  )
}
